import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import 'redux-notifications/lib/styles.css';
import App from './App';
import { unregister } from './registerServiceWorker';

import configureStore from '@utils/configureStore';

const store = configureStore();

const rootEl = document.getElementById('root') as HTMLElement;

ReactDOM.render(<App store={store} />, rootEl);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render(<NextApp />, rootEl);
  });
}

unregister();



// WEBPACK FOOTER //
// ./src/index.tsx